import React, { useEffect, useState } from "react";
import withClinic from "../hooks/with_clinic";
import { ApolloResult, Clinic, Service, ServiceRoom } from "../store";
import {
  Row,
  Col,
  Typography,
  Empty,
  Button,
  Popconfirm,
  InputNumber,
  Input,
  Switch,
} from "antd";
import Search from "antd/lib/input/Search";
import { Form } from "antd";
import { Table, message } from "antd";
import { format } from "date-fns";
import ButtonGroup from "antd/lib/button/button-group";
import { useMutation, useQuery } from "@apollo/client";
import LoadingSpinner from "../components/loading_indicator";
import Error from "../components/apollo_error";
// import MultiSelect from '../components/multi_select';
import {
  LoadingOutlined,
  EditOutlined,
  SaveOutlined,
  PlusCircleOutlined,
} from "@ant-design/icons";
// import { bool } from 'yup';
// import { uuidv4 } from '../helpers/utils';
import {
  service_rooms,
  getServiceRoomsVar,
  create_one_srv_room,
  update_one_srv_room,
  getUpdateOneSrvRoomVar,
} from "../graphql/service_room";
import { Link } from "react-router-dom";
import paths from "../routes/paths";
const { TextArea } = Input;
interface P {
  currentClinic?: Clinic;
}
interface EditableCellProps extends React.HTMLAttributes<HTMLElement> {
  editing: boolean;
  dataIndex: string;
  title: any;
  inputType: "number" | "text" | "switch" | "textarea";
  record: ServiceRoom;
  index: number;
  children: React.ReactNode;
}

const EditableCell: React.FC<EditableCellProps> = ({
  editing,
  dataIndex,
  title,
  inputType,
  record,
  index,
  children,
  ...restProps
}) => {
  let inputNode =
    inputType === "number" ? (
      <InputNumber />
    ) : inputType === "switch" ? (
      <Switch defaultChecked={record.status === "ACTIVE"} />
    ) : (
      <Input />
    );
  if (inputType === "textarea") {
    inputNode = (
      <TextArea
        key={`${dataIndex}`}
        rows={3}
        defaultValue={(record as any)[dataIndex]}
      />
    );
  }
  return (
    <td {...restProps}>
      {editing ? (
        <Form.Item
          name={dataIndex}
          style={{ margin: 0 }}
          rules={[
            {
              required: true,
              message: `Please Input ${title}!`,
            },
          ]}
        >
          {inputNode}
        </Form.Item>
      ) : (
        children
      )}
    </td>
  );
};

const OfferCategoryPage = (props: P) => {
  const clinicId = props.currentClinic?.id || "";
  // const clinicId = "clhobuntc0002s6019ajmqkcj";
  const [searchText, setSearchText] = useState<string | null>(null);
  const [form] = Form.useForm();
  const [serviceRooms, setServiceRooms] = useState<ServiceRoom[]>([]);
  const [editingKey, setEditingKey] = useState("");
  const isEditing = (record: ServiceRoom) => record.id === editingKey;
  const variables = getServiceRoomsVar(clinicId);
  const { loading, data, error, refetch } = useQuery<
    ApolloResult<"serviceRooms", ServiceRoom[]>
  >(service_rooms, { variables });
  const [update, { loading: saveLoading }] =
    useMutation<ApolloResult<"updateOneServiceRoom", ServiceRoom>>(
      update_one_srv_room
    );
  const [create, { loading: createLoading }] =
    useMutation<ApolloResult<"createOneServiceRoom", ServiceRoom>>(
      create_one_srv_room
    );
  useEffect(() => {
    if (data?.serviceRooms) {
      setServiceRooms(data.serviceRooms);
    }
  }, [data]);
  if (loading) return <LoadingSpinner />;
  if (error) return <Error error={error} />;
  if (!data) return <Empty />;
  const edit = (r: ServiceRoom) => {
    form.setFieldsValue({ ...r });
    setEditingKey(r.id!);
  };
  const add = () => {
    const newData: ServiceRoom = {
      id: `new_${new Date().getTime()}`,
      name: "New Room",
      status: "INACTIVE",
      created_at: new Date(),
      services: [],
      sort_order: 1,
    };
    const newList = [...serviceRooms];
    newList.unshift(newData);
    setServiceRooms(newList);
    setEditingKey(newData.id);
  };
  const save = async (r: ServiceRoom) => {
    if (r.id.startsWith("new_")) {
      await onCreate(r);
    } else {
      let fData = (await form.validateFields()) as { status: boolean };
      const status =
        typeof fData.status === "boolean"
          ? fData.status
          : fData.status === "ACTIVE";

      const uData = {
        ...fData,
        status: status ? "ACTIVE" : "INACTIVE",
      } as ServiceRoom;
      const result = await update({
        variables: getUpdateOneSrvRoomVar(r.id, uData),
      });
      if (result.data?.updateOneServiceRoom) {
        message.success("update success");
        await refetch();
      } else {
        message.error("update failed");
      }
    }
    form.resetFields();
    setEditingKey("");
  };
  const onCreate = async (r: ServiceRoom) => {
    let fData = (await form.validateFields()) as { status: boolean };
    let uData = {
      ...fData,
      status: fData.status === true ? "ACTIVE" : "INACTIVE",
    } as any;
    delete uData["id"];
    const result = await create({
      variables: {
        data: {
          ...uData,
          clinic: {
            connect: {
              id: clinicId,
            },
          },
        },
      },
    });

    if (result.data?.createOneServiceRoom) {
      message.success("create success");
      await refetch();
    } else {
      message.error("create failed");
    }
  };
  const onCancel = async (r: ServiceRoom) => {
    if (r.id.startsWith("new_")) {
      const newList = [...serviceRooms];
      newList.shift();
      setServiceRooms(newList);
    }
    form.resetFields();
    setEditingKey("");
  };

  const columns: any[] = [
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
      editable: true,
      filteredValue: searchText ? [searchText] : null,
      sorter: (a: ServiceRoom, b: ServiceRoom) =>
        a.name.toLowerCase().localeCompare(b.name.toLowerCase()),
      onFilter: (value: string, record: ServiceRoom) =>
        record.name.toLowerCase().includes(value.toLowerCase()),
      render: (v: ServiceRoom, r: ServiceRoom) => {
        return <Link to={paths.getServiceRoomDetailRoute(r.id)}>{r.name}</Link>;
      },
    },
    {
      title: "Staus",
      dataIndex: "status",
      key: "status",
      sorter: (a: ServiceRoom, b: ServiceRoom) =>
        a.status.localeCompare(b.status),
      editable: true,
    },
    {
      title: "Description",
      dataIndex: "description",
      key: "description",
      sorter: (a: ServiceRoom, b: ServiceRoom) =>
        a.status.localeCompare(b.status),
      editable: true,
    },
    {
      title: "Sort Order",
      dataIndex: "sort_order",
      key: "sort_order",
      editable: true,
      sorter: (a: Service, b: Service) => a.sort_order - b.sort_order,
    },
    {
      title: "CreatedAt",
      dataIndex: "created_at",
      key: "created_at",
      editable: false,
      sorter: (a: ServiceRoom, b: ServiceRoom) =>
        new Date(a.created_at).getTime() - new Date(b.created_at).getTime(),
      render: (v: ServiceRoom, r: ServiceRoom) => {
        return format(new Date(r.created_at), "dd MMM,yyyy");
      },
    },
    {
      title: "Action",
      key: "action",
      align: "center",
      width: "10%",
      dataIndex: "action",
      editable: false,
      fixed: "right",
      render: (v: number, record: ServiceRoom) => {
        const editable = isEditing(record);
        return (
          <ButtonGroup>
            {editable ? (
              saveLoading || createLoading ? (
                <Button type="primary" icon={<LoadingOutlined />}>
                  saving...
                </Button>
              ) : (
                <Popconfirm
                  placement="topRight"
                  title={`Sure to save ${record.name}?`}
                  onConfirm={() => save(record)}
                  onCancel={() => onCancel(record)}
                >
                  <Button type="primary" icon={<SaveOutlined />}>
                    save
                  </Button>
                </Popconfirm>
              )
            ) : (
              <Button
                shape="circle"
                icon={<EditOutlined />}
                onClick={() => edit(record)}
              />
            )}
          </ButtonGroup>
        );
      },
    },
  ];
  const mergedColumns = columns.map((col) => {
    if (!col.editable) {
      return col;
    }
    return {
      ...col,
      onCell: (record: ServiceRoom) => ({
        record,
        inputType:
          col.dataIndex === "sort_order"
            ? "number"
            : col.dataIndex === "status"
            ? "switch"
            : col.dataIndex === "description"
            ? "textarea"
            : "text",
        dataIndex: col.dataIndex,
        title: col.title,
        editing: isEditing(record),
      }),
    };
  });

  const control = (
    <Row style={{ marginTop: -18 }}>
      <Col flex={4}>
        <Row>
          <Col span={8}>
            <Typography level={2}>Service Rooms</Typography>
          </Col>
          <Col span={8} offset={8}>
            <Search
              defaultValue={searchText || undefined}
              placeholder="search ...."
              allowClear
              size="middle"
              onSearch={(val: any) => setSearchText(val)}
            />
          </Col>
        </Row>
      </Col>
      <Col flex={0}>
        <Button type="primary" icon={<PlusCircleOutlined />} onClick={add}>
          Add
        </Button>
      </Col>
    </Row>
  );
  const context = (
    <Row style={{ marginTop: 8 }}>
      <Col span={24}>
        <Form form={form} component={false}>
          <Table
            loading={saveLoading || createLoading || loading}
            showHeader={serviceRooms.length > 0}
            components={{ body: { cell: EditableCell } }}
            dataSource={serviceRooms.map((b) => ({ key: b.id, ...b }))}
            columns={mergedColumns}
            rowClassName="editable-row"
            pagination={false}
          />
        </Form>
      </Col>
    </Row>
  );
  return (
    <React.Fragment>
      {control}
      {context}
    </React.Fragment>
  );
};

export default withClinic(OfferCategoryPage);
